import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { ContractStatus } from './types';

const STATUS_CONFIG: Record<ContractStatus, { label: string; className: string }> = {
        active: {
                label: 'Active',
                className:
                        'bg-green-100 text-green-800 border-green-200 dark:bg-green-900/30 dark:text-green-300 dark:border-green-800'
        },
        suspended: {
                label: 'Suspended',
                className:
                        'bg-amber-100 text-amber-900 border-amber-200 dark:bg-amber-900/30 dark:text-amber-200 dark:border-amber-800'
        },
        expired: {
                label: 'Expired',
                className:
                        'bg-red-100 text-red-800 border-red-200 dark:bg-red-900/30 dark:text-red-300 dark:border-red-800'
        },
        expiringSoon: {
                label: 'Expiring soon',
                className:
                        'bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-900/30 dark:text-orange-300 dark:border-orange-800'
        },
        scheduled: {
                label: 'Scheduled',
                className:
                        'bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-800'
        }
};

interface ContractStatusBadgeProps {
        status: ContractStatus;
        className?: string;
}

export const ContractStatusBadge = ({ status, className }: ContractStatusBadgeProps) => {
        const config = STATUS_CONFIG[status];

        return (
                <Badge
                        variant="outline"
                        className={cn(
                                'text-[10px] font-semibold uppercase tracking-wide px-2 py-0.5',
                                config.className,
                                className
                        )}
                >
                        {config.label}
                </Badge>
        );
};
